const styles = theme => ({
  root: {
    // maxHeight: "200px"
    // backgroundColor: "yellow",
    // zIndex: 1
  },
  autocompleteIcon: {
    color: "black !important"
  },
  emailChip: {
    backgroundColor: "#lightgray"
  },
  tagChip: {
    backgroundColor: "#ADB4FF"
  },
  differenceChip: {
    backgroundColor: theme.palette.primary.default,
    color: "white"
  }
})
export default styles



// WEBPACK FOOTER //
// ./src/dialogs/PublishContainer/steps/Email/Autocomplete/styles.js